/**
 * Stakeholder CRUD
 */

import type { Stakeholder } from '../../graphql/types';
import { createEntityCrudClient } from './crudFactory';

export interface CreateStakeholderInput {
  name: string;
  stakeholderType: string;
  description?: string;
  contactEmail?: string;
  organization?: string;
}

export interface UpdateStakeholderInput {
  name?: string;
  stakeholderType?: string;
  description?: string;
  contactEmail?: string;
  organization?: string;
}

const client = createEntityCrudClient<Stakeholder, CreateStakeholderInput, UpdateStakeholderInput>(
  '/stakeholders'
);

/**
 * Create a new stakeholder
 */
export async function createStakeholder(input: CreateStakeholderInput): Promise<Stakeholder> {
  return client.create(input);
}

/**
 * Update an existing stakeholder
 */
export async function updateStakeholder(
  stakeholderId: string,
  input: UpdateStakeholderInput
): Promise<Stakeholder> {
  return client.update(stakeholderId, input);
}

/**
 * Delete a stakeholder
 */
export async function deleteStakeholder(
  stakeholderId: string,
  hardDelete: boolean = false
): Promise<void> {
  return client.remove(stakeholderId, hardDelete);
}
